export function sortSiteObjects(sites) {
  const alphabeticalRegexp = /^([0-9]+|BOM)[_\- ](.*)$/;
  return sites
    .filter(({mesonet}) => mesonet)
    .map(({name,slug}) => {return {label: name, value: slug}})
    .sort((a,b) => {
      const aNameMatch = a.label.match(alphabeticalRegexp);
      const bNameMatch = b.label.match(alphabeticalRegexp);
      if (aNameMatch && bNameMatch && aNameMatch[2] < bNameMatch[2]) return -1;
      if (aNameMatch && bNameMatch && aNameMatch[2] > bNameMatch[2]) return 1;
      return 0;
    })
}
